module.exports = __webpack_public_path__ + "static/media/img-openscout-reference.154cd026.png";